
import { ID, Response } from '../../../_metronic/helpers'
import {PeriodModel} from "./periodModels";

export type CustomReportCarrierModel = {
    report: CustomReportModel;
    reportDetails: Array<CustomReportDetailModel>;
    reportColumns: Array<CustomReportColumns>;
}

//BMCustomReport
export type CustomReportModel = {
    customReportID: ID;
    userID: ID | null;
    reportName: string;
    dateCreated: Date | null;
    selectedCalc: string;
    reportType: string;
    isStandardReport: boolean | null;
    userEmail?: string;
}

//BMCustomReportDetail
export type CustomReportDetailModel = {
    customReportDetailID: ID;
    calculationID: ID;
    isSelected: boolean;
    sort?: number | null;
}

//BMCustomReportColumns
export type CustomReportColumns = {
    customReportDetailID: ID;
    reportColumnID: ID;
    visible: boolean;
}

//BMFilterGroup
export interface CalculationGroups {
    filterGroupID: ID;
    filterName: string;
    sort?: string | null;
    filterGroupSort: number | null;
}

//BMCalculation
export interface Calculations {
    calculationID: ID;
    name: string;
    calculation: string;
    isDeleted: number;
    dateCreated: Date;
    isVisible: number;
    toolTip?: string | null;
    groupID?: number | null;
    procID?: number | null;
    sort?: number | null;
    displayName?: string | null;
    label?: string | null;
    labelMetric?: string | null;
    measurementSystem?: string | null;
    measurementLabel?: string | null;
    denominator?: string | null;
    denominatorUndenatured?: string | null;
    isUndenaturedCalc?: number | null;
    isDenaturedCalc?: number | null;
    multiplierID?: number | null;
    reportIDs: number[];
}


export const initialCustomReportModel: CustomReportModel = {
    customReportID: null,
    userID: null,
    reportName: '',
    dateCreated: new Date(),
    selectedCalc: '',
    reportType: '',
    isStandardReport: false
}

export const initialCustomReportCarrierModel: CustomReportCarrierModel = {
    report: initialCustomReportModel,
    reportDetails: [],
    reportColumns: []
}
